var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1862e95aa5f3e412ce045e144f5cb315dbb29c8c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-registration@docupet"]={id:"1862e95aa5f3e412ce045e144f5cb315dbb29c8c"};
      